import { useQuery } from "@apollo/client/react";
import { Loader } from "@volumental/common";
import type { JSX } from "react";
import { graphql } from "../../api/gql";
import { FlowNotSupported } from "../../navigation/flow-not-supported";
import { GeneralErrorPage } from "../error/GeneralErrorPage";
import { SelectScan } from "./select-scan";

const GetHistoryConfigurationQuery = graphql(`
  query getHistoryConfigurationQuery {
    configuration {
      features {
        enableProfiles
      }
    }
  }
`);
export interface HistoryFlowProps {
  onClose: () => void;
}

export function HistoryFlow({ onClose }: HistoryFlowProps): JSX.Element {
  const { loading, error, data } = useQuery(GetHistoryConfigurationQuery);
  if (loading) {
    return <Loader />;
  }
  if (error || !data) {
    return <GeneralErrorPage errorText="Missing HistoryFlow configuration" onClose={onClose} />;
  }
  if (!data.configuration.features.enableProfiles) {
    return <FlowNotSupported />;
  }
  return <SelectScan onClose={onClose} />;
}
